import useWindowDimensions from "./useWindowDimensions";

/**
 * The app shell on small screens (redesign). Below this width the sidebar
 * would take most of a phone's width, so pages that opt in (by rendering
 * `ResponsiveNavBar` and placing themselves with `useNavOffset`) get a top
 * bar with a menu drawer instead. Pages that have not been converted keep
 * the desktop sidebar everywhere: about 80 files still position themselves
 * with fixed pixel offsets around it, and switching them all at once would
 * break every one of them on a phone.
 */
export const MOBILE_SHELL_MAX_WIDTH_PX = 900;
export const MOBILE_TOP_BAR_PX = 56;

export const SIDEBAR_WIDTH_PX = 150;
export const SIDEBAR_COLLAPSED_WIDTH_PX = 75;

export const useIsMobileShell = (): boolean =>
  useWindowDimensions().width < MOBILE_SHELL_MAX_WIDTH_PX;

/**
 * Where a converted page's content starts: to the right of the sidebar on
 * desktop, below the top bar on small screens.
 */
export const useNavOffset = (
  navBarCollapsed: boolean
): { mobile: boolean; left: number; top: number } => {
  const mobile = useIsMobileShell();
  if (mobile) return { mobile, left: 0, top: MOBILE_TOP_BAR_PX };
  return {
    mobile,
    left: navBarCollapsed ? SIDEBAR_COLLAPSED_WIDTH_PX : SIDEBAR_WIDTH_PX,
    top: 0,
  };
};
